import { Pipe, PipeTransform } from '@angular/core';

import { colSpan } from '../constants/constants';

@Pipe({ name: 'colSpan' })
export class ColSpanPipe implements PipeTransform {
  transform(i: number, parameterGroup: string, parameterGroups: any) {
    return colSpan(i, parameterGroup, parameterGroups);
  }
}
